import React from "react";

const ThankYou = () => {
    return (
        <div style={styles.page}>
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-8 col-md-10">

                        <div style={styles.card}>

                            {/* Logo */}
                            <img
                                src="/images/logo.webp"
                                alt="logo"
                                style={styles.logo}
                            />

                            {/* Heading */}
                            <h1 style={styles.heading}>Thank You</h1>

                            {/* Message */}
                            <p style={styles.text}>
                                Thank you for showing interest in our programs.
                                Our team will contact you shortly with complete details.
                            </p>

                            {/* Buttons */}
                            <div className="d-flex flex-wrap justify-content-center gap-3 mt-4">
                                <a href="https://admissions.aryacollege.org/" style={styles.btnPrimary}>
                                    Complete Application
                                </a>
                                {/* <a href="https://www.aryacollege.org/" style={styles.btnSecondary}>
                                    College Website
                                </a> */}
                                <a href="tel:9001992258" style={styles.btnSecondary}>
                                    Call Now
                                </a>
                                <a href="https://www.instagram.com/aryacollege_official/" target="_blank" rel="noreferrer" style={styles.btnSecondary}>
                                    Visit Instagram
                                </a>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const styles = {
    page: {
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#8B0000",
        padding: "20px",
    },

    card: {
        background: "#fff",
        borderRadius: "20px",
        padding: "40px 20px",
        textAlign: "center",
        boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
        borderBottom: "8px solid #FFD700",
    },

    logo: {
        width: "250px",
        marginBottom: "15px",
    },

    heading: {
        fontSize: "42px",
        fontWeight: "700",
        color: "#8B0000",
        marginBottom: "10px",
    },

    text: {
        fontSize: "16px",
        color: "#444",
        maxWidth: "500px",
        margin: "0 auto",
        lineHeight: "1.6",
    },

    btnPrimary: {
        background: "#FFD700",
        color: "#000",
        padding: "10px 22px",
        borderRadius: "8px",
        textDecoration: "none",
        fontWeight: "600",
    },

    btnSecondary: {
        background: "#fff",
        color: "#8B0000",
        padding: "10px 22px",
        borderRadius: "8px",
        textDecoration: "none",
        border: "1px solid #8B0000",
        fontWeight: "600",
    },
};

export default ThankYou;